module.exports = __webpack_public_path__ + "img/ylb-9.0302a076.png";